import React from 'react';

function LogoDisplay({ logoPath, className = '', style = {} }) {
  if (!logoPath) {
    return null;
  }

  // Se o logoPath já é uma URL completa, usar diretamente
  // Caso contrário, assumir que é um caminho relativo
  const logoUrl = logoPath.startsWith('http') 
    ? logoPath 
    : logoPath.startsWith('/') 
      ? logoPath 
      : `/${logoPath}`;

  return (
    <img
      src={logoUrl}
      alt="Logo"
      className={className}
      style={{
        maxHeight: '60px',
        maxWidth: '200px',
        objectFit: 'contain',
        ...style
      }}
      onError={(e) => {
        // Se houver erro ao carregar, esconder a imagem
        e.target.style.display = 'none';
      }}
    />
  );
}

export default LogoDisplay;
